<template>
  <cy-drawer title="添加/编辑" v-model="visible" :loading="loading" @cancel="cancel" @confirm="submit('form')" width="70%">
    <a-form-model ref="form" :model="form" :rules="rules">
      <a-alert :message="$t('基本信息')" type="success" />
      <a-row :gutter="10">
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="$t('图片')"
          prop="mainImg"
        >
          <file-upload ref="upload" @change="uploadChange('mainImg', $event)"></file-upload>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="4"
        ><a-form-model-item
          :label="$t('视频')"
          prop="video"
        >
          <FileUploadVideo @change="uploadChange('video', $event)" />
          <!-- <a-button v-if="form.video" type="link" @click="openVideo()">{{ $t('查看视频') }} </a-button> -->
          <video v-if="form.video" :src="form.video" style="width: 100px; height: 100px; margin-top: 4px;" controls></video>
          <div>Please upload mp4 file</div>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="16"
        ><a-form-model-item
          :label="$t('菜谱标题')"
          prop="title"
        ><a-input v-model="form.title" :placeholder="$t('请输入')"></a-input></a-form-model-item
        ></a-col>
        <a-col
          :lg="6"
        ><a-form-model-item
          :label="$t('菜谱所属分类')"
          prop="classifyId"
        >
          <a-select v-model="form.classifyId" :placeholder="$t('请选择')">
            <a-select-option v-for="item in fenleiList" :key="item.id" :value="item.id">{{ item.classifyName }}</a-select-option>
          </a-select>
        </a-form-model-item
        ></a-col>
        <a-col
          :lg="12"
        ><a-form-model-item
          :label="$t('难易程度')"
          prop="level"
        >
          <a-radio-group v-model="form.level">
            <a-radio :value="1">{{ $t('简单') }}</a-radio>
            <a-radio :value="2">{{ $t('普通') }}</a-radio>
            <a-radio :value="3">{{ $t('高级') }}</a-radio>
          </a-radio-group>
        </a-form-model-item
        ></a-col>
        <!-- <a-col
          :lg="24"
        ><a-form-model-item
          :label="$t('菜谱描述')"
          prop="content"
        ><a-textarea v-model="form.content" :placeholder="$t('请输入')"></a-textarea></a-form-model-item
        ></a-col> -->

      </a-row>
      <a-alert :message="$t('配料信息')" type="info" />
      <a-row :gutter="10">
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.ingredients" :key="`zhuliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('主料名称'):''"
              :prop="`ingredients.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`ingredients.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.ingredients.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('ingredients', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">

            <a-button type="dashed" style="width: 100%;" @click="handleAdd('ingredients', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>

        </a-col>
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.excipients" :key="`fuliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('辅料名称'):''"
              :prop="`excipients.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`excipients.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.excipients.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('excipients', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">

            <a-button type="dashed" style="width: 100%;" @click="handleAdd('excipients', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>
        </a-col>
        <a-col
          :lg="8"
        >
          <div class="flex align-center" v-for="(item,index) in form.condiment" :key="`tiaoliao-${index}`">
            <a-form-model-item
              :label="index==0?$t('调料名称'):''"
              :prop="`condiment.${index}.name`"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              :label="index==0?$t('用量'):''"
              :prop="`condiment.${index}.content`"
              style="margin-left: 10px;"
              :rules="{required: true, message: $t('请输入')}"
            ><a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20"></a-input></a-form-model-item
            >
            <a-form-model-item
              prop="remark"
              style="margin-left: 10px;"
              v-if="form.condiment.length>1"
            ><a-button :style="{marginTop: index==0?'40px':''}" type="primary" shape="circle" icon="minus" @click="handleDel('condiment', index)" /></a-form-model-item
            >
          </div>
          <a-form-model-item style="width: 100%;">
            <a-button type="dashed" style="width: 100%;" @click="handleAdd('condiment', { name: '', content: '' })">{{ $t('添加') }}</a-button>
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-alert :message="$t('做法步骤')" type="info" />
      <a-row :gutter="10" v-for="(item,index) in form.stepAddParamList" :key="`zuofa-${index}`">
        <!-- <a-col
          :lg="4"
        ><a-form-model-item
          :label="index==0?$t('图片'):''"
          :prop="`stepAddParamList.${index}.img`"
          :rules="{required: false, message: $t('请上传图片')}"
        >
          <file-upload :ref="`stepAddParamList${index}`" @change="handleSetpUpload(index, $event)"></file-upload>
        </a-form-model-item
        >
        </a-col> -->
        <a-col
          :lg="20"
        ><a-form-model-item
          :label="index==0?$t('内容'):''"
          :prop="`stepAddParamList.${index}.content`"
          :rules="{required: true, message: $t('请输入')}"
        >
          <div class="flex align-center">
            <a-textarea rows="1" v-model="item.content" :placeholder="$t('请输入')" :maxLength="255"></a-textarea>
            <a-button
              v-if="form.stepAddParamList.length>1"
              class="flex-shrink"
              style="margin-left: 10px;"
              type="primary"
              shape="circle"
              icon="minus"
              @click="handleDel('stepAddParamList', index)"
            ></a-button>
          </div>
        </a-form-model-item
        >
        </a-col>
      </a-row>
      <a-button
        type="dashed"
        style="width: 100%;"
        @click="handleAdd('stepAddParamList', {
          'content': '',
          'img': '',
          'remark': '',
          'sort': form.stepAddParamList[form.stepAddParamList.length-1].sort+1,
        })">{{ $t('添加') }}</a-button>

      <template v-if="showI18n && langList.length">
        <a-divider>{{ $t('多语言翻译') }}</a-divider>
        <a-tabs v-model="activeLang">
          <a-tab-pane v-for="lang in langList" :key="lang.dictValue" :tab="lang.dictLabel">
            <a-form-model-item :label="$t('菜谱标题') + '（' + lang.dictLabel + '）'">
              <a-input v-model="titleI18nMap[lang.dictValue]" :placeholder="$t('请输入')" />
            </a-form-model-item>
            <!-- <a-form-model-item :label="$t('菜谱描述') + '（' + lang.dictLabel + '）'">
              <a-textarea v-model="contentI18nMap[lang.dictValue]" :placeholder="$t('请输入')" :rows="3" />
            </a-form-model-item> -->

            <a-alert :message="$t('配料信息') + '（' + lang.dictLabel + '）'" type="info" style="margin-bottom: 12px;" />
            <a-row :gutter="10">
              <a-col :lg="8">
                <div
                  class="flex align-center"
                  v-for="(item, index) in (ingredientsI18nMap[lang.dictValue] || [])"
                  :key="`i18n-zhuliao-${lang.dictValue}-${index}`"
                >
                  <a-form-model-item :label="index === 0 ? $t('主料名称') : ''">
                    <a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20" />
                  </a-form-model-item>
                  <a-form-model-item :label="index === 0 ? $t('用量') : ''" style="margin-left: 10px;">
                    <a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20" />
                  </a-form-model-item>
                </div>
              </a-col>
              <a-col :lg="8">
                <div
                  class="flex align-center"
                  v-for="(item, index) in (excipientsI18nMap[lang.dictValue] || [])"
                  :key="`i18n-fuliao-${lang.dictValue}-${index}`"
                >
                  <a-form-model-item :label="index === 0 ? $t('辅料名称') : ''">
                    <a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20" />
                  </a-form-model-item>
                  <a-form-model-item :label="index === 0 ? $t('用量') : ''" style="margin-left: 10px;">
                    <a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20" />
                  </a-form-model-item>
                </div>
              </a-col>
              <a-col :lg="8">
                <div
                  class="flex align-center"
                  v-for="(item, index) in (condimentI18nMap[lang.dictValue] || [])"
                  :key="`i18n-tiaoliao-${lang.dictValue}-${index}`"
                >
                  <a-form-model-item :label="index === 0 ? $t('调料名称') : ''">
                    <a-input v-model="item.name" :placeholder="$t('请输入')" :maxLength="20" />
                  </a-form-model-item>
                  <a-form-model-item :label="index === 0 ? $t('用量') : ''" style="margin-left: 10px;">
                    <a-input v-model="item.content" :placeholder="$t('例：1个')" :maxLength="20" />
                  </a-form-model-item>
                </div>
              </a-col>
            </a-row>

            <a-alert :message="$t('做法步骤') + '（' + lang.dictLabel + '）'" type="info" style="margin-bottom: 12px;" />
            <a-form-model-item
              v-for="(stepContent, index) in (stepI18nMap[lang.dictValue] || [])"
              :key="`i18n-step-${lang.dictValue}-${index}`"
              :label="$t('内容') + ' ' + (index + 1)"
            >
              <a-textarea v-model="stepI18nMap[lang.dictValue][index]" :placeholder="$t('请输入')" :rows="2" :maxLength="255" />
            </a-form-model-item>
          </a-tab-pane>
        </a-tabs>
      </template>
    </a-form-model>

    <a-button
      slot="footer"
      :style="{ float: 'left', marginRight: '8px' }"
      :loading="translateLoading"
      @click="handleTranslate"
    >
      {{ $t('翻译') }}
    </a-button>
  </cy-drawer>
</template>
<script>
import CyDrawer from '@/components/CyDarwer'
import { mapGetters } from 'vuex'
import { addObj, putObj, getObj, autoTranslate } from '../api'
import { fetchList } from '@/views/program/repice-category/api'
import { pageData } from '@/api/system/dict/data'

function createEmptyForm() {
  return {
    classifyId: undefined,
    condiment: [{ name: '', content: '' }],
    content: '',
    excipients: [{ name: '', content: '' }],
    id: 0,
    ingredients: [{ name: '', content: '' }],
    level: 1,
    mainImg: '',
    remark: '',
    stepAddParamList: [
      {
        content: '',
        img: '',
        remark: '',
        sort: 0,
        contentI18n: undefined
      }
    ],
    summarized: '',
    title: '',
    video: '',
    titleI18n: undefined,
    contentI18n: undefined,
    ingredientsI18n: undefined,
    excipientsI18n: undefined,
    condimentI18n: undefined,
    summarizedI18n: undefined
  }
}

export default {
  // 组件名称
  name: 'CreateForm',
  // 过滤器
  filters: {},
  // 组件
  components: {
    CyDrawer,
    FileUpload: () => import('@/components/FileUpload/index2'),
    FileUploadVideo: () => import('@/components/FileUpload/indexVideo')
  },
  // props类型
  props: {
    model: {
      type: Object,
      default: () => null
    }
  },
  // 数据

  data() {
    return {
      visible: false,
      loading: false,
      translateLoading: false,
      showI18n: false,
      langList: [],
      activeLang: undefined,
      titleI18nMap: {},
      contentI18nMap: {},
      ingredientsI18nMap: {},
      excipientsI18nMap: {},
      condimentI18nMap: {},
      stepI18nMap: {},
      labelCol: { span: 24 },
      wrapperCol: { span: 24 },
      URL: process.env.VUE_APP_API_BASE_URL + '/api/common/upload',
      baseurl: process.env.VUE_APP_API_BASE_URL,
      imgList: [],
      form: createEmptyForm(),
      rules: {
        classifyId: [{ required: true, message: this.$t('请选择') }],
        title: [{ required: true, message: this.$t('请输入') }],
        mainImg: [{ required: true, message: this.$t('请上传封面图') }]
      },
      editFlag: true,
      select: {
        provinceId: null,
        cityId: null,
        areaId: null
      },
      fenleiList: []
    }
  },
  // 计算属性
  computed: {
    ...mapGetters(['roleList'])
  },
  // 计算属性监听
  watch: {},
  // 创建时
  created() {
    this.getFenleiList()
    this.loadTranslateLangs()
  },
  // 挂载完毕
  mounted() {},
  // 方法
  methods: {
    loadTranslateLangs() {
      return pageData({
        dictType: 'cooking_translate_lang',
        pageNum: 1,
        pageSize: 100
      }).then((res) => {
        const records = (res.data && res.data.records) || []
        this.langList = records.slice().sort((a, b) => (a.dictSort || 0) - (b.dictSort || 0))
        if (this.langList.length && !this.activeLang) {
          this.activeLang = this.langList[0].dictValue
        }
        this.applyI18nFromForm()
      })
    },
    parseI18nJson(str) {
      if (str == null || str === '') return {}
      if (typeof str === 'object') {
        if (Array.isArray(str)) return {}
        return str || {}
      }
      try {
        const parsed = JSON.parse(str)
        if (parsed == null) return {}
        if (typeof parsed === 'string') return this.parseI18nJson(parsed)
        if (typeof parsed === 'object' && !Array.isArray(parsed)) return parsed || {}
        return {}
      } catch (e) {
        return {}
      }
    },
    normalizeMaterialItem(item) {
      if (!item || typeof item !== 'object') return { name: '', content: '' }
      const name = item.name || item.nom || item.nome || item.Name || item.Nom || ''
      const content = item.content || item.contenu || item.contenuto || item.Content || item.Contenu || ''
      return {
        name: typeof name === 'string' ? name : '',
        content: typeof content === 'string' ? content : ''
      }
    },
    // 翻译服务常把 JSON 译坏，先做常见修复再 parse
    fixMaterialJsonString(str) {
      let s = String(str || '').trim()
      if (!s) return s
      // 去掉首尾多余引号
      if ((s.startsWith('"') && s.endsWith('"')) || (s.startsWith("'") && s.endsWith("'"))) {
        try {
          const unquoted = JSON.parse(s)
          if (typeof unquoted === 'string') s = unquoted
        } catch (e) { /* ignore */ }
      }
      // " nom " / " contenu " → "nom" / "contenu"
      s = s.replace(/"\s*(name|nom|nome|content|contenu|contenuto)\s*"/gi, '"$1"')
      // contenu ": "xxx" → "contenu": "xxx"
      s = s.replace(/([{,]\s*)(name|nom|nome|content|contenu|contenuto)\s*"\s*:/gi, '$1"$2":')
      // "value", { → "value"}, {
      s = s.replace(/("(?:\\.|[^"\\])*")\s*,\s*\{/g, '$1}, {')
      // } { → }, {
      s = s.replace(/\}\s*\{/g, '}, {')
      // 多余逗号 ],
      s = s.replace(/,\s*]/g, ']')
      return s
    },
    // 从损坏字符串里按 name/content 类字段顺序提取
    extractMaterialListByRegex(str) {
      const text = String(str || '')
      // 兼容 "nom":"x" / nom ":"x" / " nom " : "x"
      const pairRe = /["\s{,]*(name|nom|nome|content|contenu|contenuto)["\s]*:\s*"([^"\\]*(?:\\.[^"\\]*)*)"/gi
      const pairs = []
      let match
      while ((match = pairRe.exec(text)) !== null) {
        pairs.push({
          key: match[1].toLowerCase(),
          value: match[2].replace(/\\"/g, '"').replace(/\\n/g, '\n').trim()
        })
      }
      const list = []
      let current = null
      pairs.forEach((pair) => {
        const isName = ['name', 'nom', 'nome'].includes(pair.key)
        const isContent = ['content', 'contenu', 'contenuto'].includes(pair.key)
        if (isName) {
          if (current && (current.name || current.content)) list.push(current)
          current = { name: pair.value, content: '' }
        } else if (isContent) {
          if (!current) current = { name: '', content: pair.value }
          else current.content = pair.value
        }
      })
      if (current && (current.name || current.content)) list.push(current)
      return list.length ? list : [{ name: '', content: '' }]
    },
    parseMaterialList(val) {
      if (val == null || val === '') return [{ name: '', content: '' }]
      if (Array.isArray(val)) {
        const list = val.map((item) => this.normalizeMaterialItem(item)).filter((item) => item.name || item.content)
        return list.length ? list : [{ name: '', content: '' }]
      }
      if (typeof val === 'object') {
        return [this.normalizeMaterialItem(val)]
      }
      if (typeof val === 'string') {
        const raw = val.trim()
        if (!raw || raw === 'null' || raw === '[]') return [{ name: '', content: '' }]
        const candidates = [raw, this.fixMaterialJsonString(raw)]
        for (let i = 0; i < candidates.length; i++) {
          try {
            const parsed = JSON.parse(candidates[i])
            if (parsed == null) continue
            const list = this.parseMaterialList(parsed)
            if (list.some((item) => item.name || item.content)) return list
          } catch (e) { /* try next */ }
        }
        return this.extractMaterialListByRegex(raw)
      }
      return [{ name: '', content: '' }]
    },
    initSimpleI18nMap(obj) {
      const source = obj || {}
      const map = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        map[key] = source[key] != null ? source[key] : ''
      })
      return map
    },
    initMaterialI18nMap(obj) {
      const source = obj || {}
      const map = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        map[key] = this.parseMaterialList(source[key])
      })
      return map
    },
    initStepI18nMap(stepList) {
      const map = {}
      const list = stepList || []
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        map[key] = list.map((step) => {
          const stepObj = this.parseI18nJson(step && step.contentI18n)
          return stepObj[key] != null ? stepObj[key] : ''
        })
      })
      return map
    },
    normalizeI18nFields(data) {
      const i18nKeys = [
        'titleI18n',
        'contentI18n',
        'ingredientsI18n',
        'excipientsI18n',
        'condimentI18n',
        'summarizedI18n'
      ]
      i18nKeys.forEach((key) => {
        if (data[key] == null || data[key] === '' || data[key] === 'null') {
          data[key] = undefined
        }
      })
      return data
    },
    applyI18nData({
      titleI18n,
      contentI18n,
      ingredientsI18n,
      excipientsI18n,
      condimentI18n,
      stepList
    } = {}) {
      const titleObj = this.parseI18nJson(titleI18n)
      const contentObj = this.parseI18nJson(contentI18n)
      const ingredientsObj = this.parseI18nJson(ingredientsI18n)
      const excipientsObj = this.parseI18nJson(excipientsI18n)
      const condimentObj = this.parseI18nJson(condimentI18n)
      const hasData =
        Object.keys(titleObj).length > 0 ||
        Object.keys(contentObj).length > 0 ||
        Object.keys(ingredientsObj).length > 0 ||
        Object.keys(excipientsObj).length > 0 ||
        Object.keys(condimentObj).length > 0 ||
        (stepList || []).some((s) => s && s.contentI18n)

      if (!this.langList.length) return

      this.titleI18nMap = this.initSimpleI18nMap(titleObj)
      this.contentI18nMap = this.initSimpleI18nMap(contentObj)
      this.ingredientsI18nMap = this.initMaterialI18nMap(ingredientsObj)
      this.excipientsI18nMap = this.initMaterialI18nMap(excipientsObj)
      this.condimentI18nMap = this.initMaterialI18nMap(condimentObj)
      this.stepI18nMap = this.initStepI18nMap(stepList || this.form.stepAddParamList || [])

      if (hasData) {
        this.showI18n = true
        if (!this.activeLang) this.activeLang = this.langList[0].dictValue
      }
    },
    applyI18nFromForm() {
      this.applyI18nData({
        titleI18n: this.form.titleI18n,
        contentI18n: this.form.contentI18n,
        ingredientsI18n: this.form.ingredientsI18n,
        excipientsI18n: this.form.excipientsI18n,
        condimentI18n: this.form.condimentI18n,
        stepList: this.form.stepAddParamList
      })
    },
    buildSimpleI18n(map) {
      const obj = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        if (map[key]) obj[key] = map[key]
      })
      return Object.keys(obj).length ? JSON.stringify(obj) : undefined
    },
    buildMaterialI18n(map) {
      const obj = {}
      this.langList.forEach((lang) => {
        const key = lang.dictValue
        const list = map[key] || []
        const hasValue = list.some((item) => item.name || item.content)
        if (hasValue) obj[key] = list
      })
      return Object.keys(obj).length ? JSON.stringify(obj) : undefined
    },
    applyStepI18nToForm() {
      const steps = this.form.stepAddParamList || []
      steps.forEach((step, index) => {
        const obj = {}
        this.langList.forEach((lang) => {
          const key = lang.dictValue
          const text = (this.stepI18nMap[key] || [])[index]
          if (text) obj[key] = text
        })
        step.contentI18n = Object.keys(obj).length ? JSON.stringify(obj) : undefined
      })
    },
    handleTranslate() {
      if (!this.form.title) {
        this.$message.warning(this.$t('请先填写标题'))
        return
      }
      this.translateLoading = true
      autoTranslate({
        title: this.form.title,
        content: this.form.content,
        summarized: this.form.summarized,
        ingredients: JSON.stringify(this.form.ingredients || []),
        excipients: JSON.stringify(this.form.excipients || []),
        condiment: JSON.stringify(this.form.condiment || []),
        steps: (this.form.stepAddParamList || []).map((item) => ({
          content: item.content,
          sort: item.sort
        }))
      })
        .then((res) => {
          const data = res.data || {}
          this.form.titleI18n = data.titleI18n
          this.form.contentI18n = data.contentI18n
          this.form.ingredientsI18n = data.ingredientsI18n
          this.form.excipientsI18n = data.excipientsI18n
          this.form.condimentI18n = data.condimentI18n
          this.form.summarizedI18n = data.summarizedI18n

          const stepResultList = data.steps || []
          ;(this.form.stepAddParamList || []).forEach((step) => {
            const matched = stepResultList.find((s) => s.sort === step.sort)
            if (matched) step.contentI18n = matched.contentI18n
          })

          this.applyI18nFromForm()
          this.showI18n = true
          if (this.langList.length && !this.activeLang) {
            this.activeLang = this.langList[0].dictValue
          }
          this.$message.success(this.$t('翻译成功'))
        })
        .finally(() => {
          this.translateLoading = false
        })
    },
    openVideo() {
      window.open(this.form.video, '_blank')
    },
    getFenleiList() {
      fetchList({ pageNum: 1, pageSize: 2 ** 31 - 1 }).then(res => {
        console.log(res)
        this.fenleiList = res.data.records
      })
    },
    handleDel(key, index) {
      this.form[key].splice(index, 1)
      this.$forceUpdate()
      setTimeout(() => {
        if (key === 'stepAddParamList') {
          this.form.stepAddParamList.map((item, index) => {
            this.$refs[`stepAddParamList${index}`].init({
              fileExplainName: item.img,
              filePath: item.img,
              fileId: item.img
            }, 782, 483)
          })
        }
      }, 0)
    },
    handleAdd(key, obj) {
      this.form[key].push(JSON.parse(JSON.stringify(obj)))
    },
    uploadChange(key, e) {
      console.log('===', key, e)
      this.form[key] = e ? e.url : undefined
    },
    handleSetpUpload(index, e) {
      this.form.stepAddParamList[index].img = e ? e.url : undefined
    },
    editorChange(e) {
      console.log(e)
      if (e === '<p><br></p>') {
        this.form.content = ''
      } else {
        this.form.content = e
      }
    },
    handleUploadChange(values) {
      console.log(values)
      this.form.iamTypeNum = values.length > 1 ? 2 : 1
      this.form.iamgePaths = values.map((item) => item.shortcutUrl).join(',')
    },
    del(index) {
      this.form.propDrops.splice(index, 1)
    },
    addDomain() {
      const obj = {
        propNum: undefined,
        num: 0,
        infeRate: 0
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.form.propDrops.push(JSON.parse(JSON.stringify(obj)))
        }
      })
    },
    resetI18n() {
      this.showI18n = false
      this.translateLoading = false
      this.titleI18nMap = {}
      this.contentI18nMap = {}
      this.ingredientsI18nMap = {}
      this.excipientsI18nMap = {}
      this.condimentI18nMap = {}
      this.stepI18nMap = {}
    },
    init(id) {
      this.form = createEmptyForm()
      this.resetI18n()
      if (id) this.form.id = id
      this.visible = true
      if (!this.langList.length) this.loadTranslateLangs()
      this.$nextTick(() => {
        console.log(this.$refs)

        if (id) {
          this.loading = true
          getObj(this.form.id).then((res) => {
            const keyArr = ['condiment', 'excipients', 'ingredients']
            this.form = this.normalizeI18nFields({
              ...createEmptyForm(),
              ...(res.data || {})
            })
            this.$refs.upload.init(this.form.mainImg ? {
              fileExplainName: this.form.mainImg,
              filePath: this.form.mainImg,
              fileId: this.form.id
            } : '', 782, 483)
            keyArr.forEach((key) => {
              this.form[key] = this.parseMaterialList(this.form[key])
            })
            const stepList = this.form.stepResultList || this.form.stepAddParamList || []
            this.form.stepAddParamList = Array.isArray(stepList) ? stepList : []
            this.form.stepAddParamList.forEach((step) => {
              if (step && (step.contentI18n == null || step.contentI18n === '' || step.contentI18n === 'null')) {
                step.contentI18n = undefined
              }
            })
            setTimeout(() => {
              this.form.stepAddParamList.map((item, index) => {
                if (this.$refs[`stepAddParamList${index}`] && this.$refs[`stepAddParamList${index}`][0]) {
                  this.$refs[`stepAddParamList${index}`][0].init({
                    fileExplainName: item.img,
                    filePath: item.img,
                    fileId: item.img
                  }, 782, 483)
                }
              })
            }, 0)

            this.applyI18nFromForm()
            console.log(this.form)
          }).finally(() => {
            this.loading = false
          })
        } else {
          console.log('初始化图片')
          setTimeout(() => {
            this.$refs.upload.init('', 782, 483)
          }, 600)
        }
      })
    },
    cancel() {
      this.visible = false
      this.form = createEmptyForm()
      this.resetI18n()
      this.$emit('close')
    },
    submit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.loading = true
          this.applyStepI18nToForm()
          const from = JSON.parse(JSON.stringify(this.form))
          const keyArr = ['condiment', 'excipients', 'ingredients']
          for (const key in from) {
            if (keyArr.includes(key)) {
              from[key] = JSON.stringify(from[key])
            }
          }
          from.titleI18n = this.buildSimpleI18n(this.titleI18nMap)
          from.contentI18n = this.buildSimpleI18n(this.contentI18nMap)
          from.ingredientsI18n = this.buildMaterialI18n(this.ingredientsI18nMap)
          from.excipientsI18n = this.buildMaterialI18n(this.excipientsI18nMap)
          from.condimentI18n = this.buildMaterialI18n(this.condimentI18nMap)
          console.log(from)
          if (from.id) {
            putObj({ ...from })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          } else {
            addObj({ ...from })
              .then((res) => {
                this.cancel()
                this.$emit('refresh')
              })
              .catch(() => {
                this.loading = false
              })
          }
        }
      })
    },
    handlecoverPicList(e) {
      console.log(e)
      if (e.length > 0) {
        this.form.avatar = e[0].url
      }
    },
    change() {},
    selected(e) {
      console.log(e)
      this.form.province = e.province.value
      this.form.city = e.city.value
      this.form.area = e.area.value
    }
  }
}
</script>

<style lang="less" scoped>
.amap-demo {
  height: 300px;
}

.avatar-uploader > .ant-upload {
  width: 128px;
  height: 128px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}
.dynamic-delete-button {
  cursor: pointer;
  position: relative;
  top: 4px;
  font-size: 24px;
  color: #999;
  transition: all 0.3s;
}
.daoju {
  position: relative;
  .del {
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
  }
}
</style>
